import { useState, useContext } from 'react'
import { Handle, Position, useReactFlow } from '@xyflow/react';
import EditIcon from '@mui/icons-material/Edit';
import HubIcon from '@mui/icons-material/Hub';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";

function WorkflowStartNode({ id, data }) {
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();

    return (
        <div className="workflow-node start">
            <span>{ data.label }</span>
            <Handle type="source" position={Position.Bottom} />
        </div>
    );
}

export default WorkflowStartNode;